/**
 * Where the net diagnostics panel is loaded, and the only place that knows it exists.
 *
 * The import is dynamic and sits behind `import.meta.env.DEV`, which Vite replaces with `false` in
 * a production build. The branch then folds away and takes the panel with it, so no player
 * downloads a tool for forcing join codes and reading candidate types.
 * `tools/bin/bundle-check.sh` fails the build if it survives.
 *
 * Returns immediately, the way `attachShotHarness` does. The module lands a frame or two later and
 * attaches itself to a lobby that is already running, which costs nothing: it observes a session
 * rather than starting one.
 */

import type { LobbySession } from '@/net/lobby/lobbySession';

export interface NetPanel {
  dispose(): void;
}

/** Attaches the panel when the URL asks for one, in development. Otherwise does nothing at all. */
export function attachNetPanel(container: HTMLElement, session: LobbySession): NetPanel {
  let panel: NetPanel | null = null;
  let disposed = false;

  if (import.meta.env.DEV) {
    void import('@/dev/netPanelLoader').then((module) => {
      if (disposed) return;
      panel = module.loadNetPanel(window.location.search, container, session);
    });
  }

  return {
    dispose(): void {
      disposed = true;
      panel?.dispose();
      panel = null;
    },
  };
}
